document.addEventListener('DOMContentLoaded', () => {
  const accordions = document.querySelectorAll('accordion-footer');
  if (!accordions.length) return;

  const mq = window.matchMedia('(max-width: 767px)');

  function closeAccordion(acc) {
    const list = acc.querySelector('.menu-block-list');
    const icon = acc.querySelector('[rotate-icon]');
    if (!list) return;

    const currentHeight = list.scrollHeight;
    list.style.height = currentHeight + 'px';
    void list.offsetHeight; 
    list.classList.remove('is-open');
    list.style.height = '0px';
    if (icon) icon.classList.add('rotate-180');
  }

  function setupAccordion(acc, enable) {
    const btn  = acc.querySelector('[toggle-accordion]');
    const list = acc.querySelector('.menu-block-list');
    const icon = acc.querySelector('[rotate-icon]');

    if (!btn || !list) return;

    if (btn._accordionHandler) {
      btn.removeEventListener('click', btn._accordionHandler);
      btn._accordionHandler = null;
    }

    if (list._transitionHandler) {
      list.removeEventListener('transitionend', list._transitionHandler);
      list._transitionHandler = null;
    }

    if (enable) {
      list.style.overflow = 'hidden';
      list.style.height = '0px';
      list.classList.remove('is-open');
      icon && icon.classList.add('rotate-180');

      list._transitionHandler = (e) => {
        if (e.propertyName !== 'height') return;
        if (list.classList.contains('is-open')) {
          list.style.height = 'auto';
        }
      };
      list.addEventListener('transitionend', list._transitionHandler);

      btn._accordionHandler = () => {
        const isOpening = !list.classList.contains('is-open');

        if (isOpening) {
          accordions.forEach(otherAcc => {
            if (otherAcc !== acc) {
              closeAccordion(otherAcc);
            }
          });

          list.classList.add('is-open');
          list.style.height = '0px';
          const fullHeight = list.scrollHeight;
          list.style.height = fullHeight + 'px';
          icon && icon.classList.remove('rotate-180');
        } else {
          closeAccordion(acc);
        }
      };

      btn.addEventListener('click', btn._accordionHandler);
    } else {
      list.classList.add('is-open');
      list.style.overflow = '';
      list.style.height = 'auto';
      icon && icon.classList.remove('rotate-180');
    }
  }

  function applyAll(enable) {
    accordions.forEach(acc => setupAccordion(acc, enable));
  }

  applyAll(mq.matches);

  mq.addEventListener('change', (e) => {
    applyAll(e.matches);
  });
});